import { useInfiniteQuery } from 'react-query'
import { getDemandLoans, TDemandSort } from 'services/loans'

export default function useGetLoans(
    id: string | undefined,
    sort: TDemandSort = 'oldest'
) {
    const {
        data,
        isLoading,
        fetchNextPage,
        refetch,
        hasNextPage,
        isFetchingNextPage,
    } = useInfiniteQuery(
        ['money-pools-fund-demand-loans', id, sort],
        ({ pageParam = 1 }) => getDemandLoans(pageParam, id, sort),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        demandLoans: data,
        isLoadingDemandLoans: isLoading,
        refetch,
        fetchNextPage,
        // sorting the queue by رتبهٔ اعتباری has to sort the WHOLE queue, not
        // the page that happens to be on screen — so the list needs to know
        // whether there is more to pull before it can order anything
        hasNextPage,
        isFetchingNextPage,
    }
}
